import { markRaw } from 'vue';
import { ManifoldBridgeProvider } from '@manifoldxyz/manifold-provider-client';

export function getManifoldBridgeProvider(network: number): ManifoldBridgeProvider {
  return markRaw(new ManifoldBridgeProvider(network));
}
